import { Rate } from "antd";
import "../../Styles/Web.css";

export const WebHeader = ({color, logo, portada, location}) => {
    
    return (
        <header id='inicio' className="web-header" style={{ backgroundImage: `url(${portada})` }}>

            <div className="logo" style={{ position: 'absolute', zIndex: 999, top: 20, left: 20 }}>
                <img src={logo} />
            </div>

            <div style={{ zIndex: 999, marginRight: '10px', paddingTop:'60px', wordWrap: 'break-word', width:'90%' }}>
                <h2 style={{ fontWeight: 600, color: 'white', textAlign: 'start' }}>{location.categories?.primaryCategory?.displayName}</h2>
                <h1 className="web-header-title" >{location?.title}</h1>
                {/*<div className="web-header-score">2.5  <Rate style={{ fontSize: '15px', color: 'orange' }} disabled defaultValue={4} /></div>*/}
            </div>

            <div className="web-header-menu">
                <ul>
                    <li>
                        <a href="#inicio">Inicio</a>
                    </li>
                    <li>
                        <a href="#local">Local</a>
                    </li>
                    <li>
                        <a href="#testimonios">Testimonios</a>
                    </li>
                    <li>
                        <a href="#contacto">Contacto</a>
                    </li>
                </ul>
            </div>
            <div className='color-div' style={{backgroundColor:`${color}`}}></div>
        </header>
    )
}